import { useEffect } from "react";
import { useDownloadReportPDF } from "../api/ReportsApi";
import LoadingSpinner from "../shared-components/LoadingSpinner";
import { useApplicationToast } from "../webcontent/ApplicationToastProvider";
import { ExclamationTriangleIcon } from "@heroicons/react/24/outline";
import { usePermissionValidator } from "../api/UserPermissionValidators";

type PDFDownloadWrapperProps = {
  report_uuid: string;
  children: React.ReactNode;
  pdf_type?: string; // reports|company
};

const PDFDownloadWrapper = ({
  report_uuid,
  children,
  pdf_type = "reports",
}: PDFDownloadWrapperProps) => {
  const { showLargeToast } = useApplicationToast();
  const { canDownloadPDF } = usePermissionValidator();

  const {
    isLoading: loadingPDF,
    mutate: downloadReportPDF,
    error: pdfError,
  } = useDownloadReportPDF(pdf_type);

  useEffect(() => {
    if (pdfError) {
      showLargeToast?.({
        title: "Error!",
        message:
          "Couldn't download pdf please try again later or contact support.",
        icon: (
          <div className="bg-red-100 text-red-600 rounded-full p-2">
            <ExclamationTriangleIcon className="w-6" />
          </div>
        ),
      });
    }
  }, [pdfError, showLargeToast]);

  function handlePDFDownload(report_uuid: string) {
    downloadReportPDF(report_uuid);
  }

  if (!canDownloadPDF) {
    return <></>;
  }

  return (
    <div>
      {loadingPDF ? (
        <LoadingSpinner />
      ) : (
        <span
          title="Download PDF"
          onClick={() => handlePDFDownload(report_uuid)}
        >
          {children}
        </span>
      )}
    </div>
  );
};

export default PDFDownloadWrapper;
